/**
 * Models and interfaces for Knowledge Base
 */

export interface KnowledgeBaseMessage {
  role: 'user' | 'assistant';
  content: string;
  timestamp: Date;
  sources?: DocumentSource[];
}

export interface DocumentSource {
  filename?: string;
  location?: string;
  uri?: string;
  s3Location?: string;
  score?: number;
  content_preview?: string;
}

export interface AgentResponse {
  answer: string;
  sources?: DocumentSource[];
  metadata?: Record<string, any>;
  status?: string;
}

export interface KnowledgeBaseQueryParams {
  sessionId: string;
  userQuestion: string;
  tenantId: string;
  role?: string;
  topic?: string;
  numberOfResults?: number;
  score?: number;
  conversationContext?: ConversationContext[];
  rolePublic?: boolean;
  roleAdmin?: boolean;
  roleSpeaker?: boolean;
  roleAttendee?: boolean;
  roleDm?: boolean;
  roleBm?: boolean;
  roleRep?: boolean;
  speakerTopics?: string[];
  attendeeTopics?: string[];
}

export interface ConversationContext {
  user: string;
  assistant: string | AgentResponse;
  timestamp: string;
}

export interface MetadataAttributes {
  tenantId: string;
  topic?: string;
  role_public?: boolean;
  role_admin?: boolean;
  role_speaker?: boolean;
  role_attendee?: boolean;
  role_dm?: boolean;
  role_bm?: boolean;
  role_rep?: boolean;
  speaker_topics?: string[];
  attendee_topics?: string[];
}

export interface RetrieveFilter {
  andAll: Array<{
    equals?: {
      key: string;
      value: any;
    };
    orAll?: Array<{
      equals: {
        key: string;
        value: any;
      };
    }>;
  }>;
}

